import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper/public-api';
import { PostnewJob } from '../../services/job-section.service';

@Component({
  selector: 'app-job-details-preview',
  templateUrl: './job-details-preview.component.html',
  styleUrls: ['./job-details-preview.component.scss']
})
export class JobDetailsPreviewComponent implements OnInit {


  images: any[] = [];
  videos: any[] = [];
  public clientsConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 5,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: false,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: false,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
  }

  public onIndexChange(index: number) {
  }

  constructor(
    public dialogRef: MatDialogRef<JobDetailsPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private jobService: PostnewJob,
  ) {

  }

  visibleImages: any[];
  remainingCount: number = 0;
  isModalOpen: boolean = false;
  currentImage: string = '';
  currentIndex: number = 0;
  showMap = false;

  previewLoader = false;
  galleryImages:any
  jobDescription :any;
  aboutComDescription :any;
  showFull = false;
  showFullAboutCom = false;


  ngOnInit(): void {
    this.previewLoader = true;
    if (this.data.postPreview) {
      this.previewLoader = false;
      this.jobDescription = this.data?.ejobdesp;
      this.aboutComDescription = this.data?.aboutCompanyData?.description;
    }
    

    if (this.data?.id) {
      this.loadJobDetailsPreview(this.data.id);
      
    }
    // Compute visibleImages **after** data is loaded
    const images = this.data?.clinicImages?.length ? this.data.clinicImages : this.data?.clinic_logo;
    if (images?.length > 0) {
      this.visibleImages = images.slice(0, 4);
      this.remainingCount = images.length - 3;
    } else {
      this.visibleImages = [];
      this.remainingCount = 0;
    }

  }

  private loadJobDetailsPreview(id: string | number): void {
    this.jobService.gettingJobDetailsPreview(id).subscribe({
      next: (res: any[]) => {
        if (res?.length) {
          this.data = res[0];
       
          this.previewLoader = false;
          this.jobDescription = this.data?.description;

          this.aboutComDescription = this.data?.dental_practice?.directories?.length 
          ? this.data.dental_practice.directories[0]?.description 
          : this.data?.dental_supplier?.directories?.length 
            ? this.data.dental_supplier.directories[0]?.description : ''


          // Compute visibleImages **after** data is loaded
          const images = this.data?.clinicImages?.length ? this.data.clinicImages : this.data?.clinic_logo;
          if (images?.length > 0) {
            this.visibleImages = images.slice(0, 4);
            this.remainingCount = images.length - 3;
          } else {
            this.visibleImages = [];
            this.remainingCount = 0;
          }
        }
      },
      error: () => {
        this.previewLoader = false;
        this.visibleImages = [];
        this.remainingCount = 0;
      }
    });
  }


  openModal(index: number): void {

     this.galleryImages = this.data?.clinicImages?.length
      ? this.data.clinicImages
      : this.data?.clinic_logo;
    
    this.currentIndex = index;
    this.currentImage = this.galleryImages[index].url;
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
  }

  prevImage(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.currentImage = this.galleryImages[this.currentIndex].url;
    }
  }

  nextImage(): void {
    if (this.currentIndex < this.galleryImages.length - 1) {
      this.currentIndex++;
      this.currentImage = this.galleryImages[this.currentIndex].url;
    }
  }

  openMap(): void {

    const location = this.data?.elocation || this.data?.location;


    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: location }, (results, status) => {
      if (status === 'OK' && results && results.length > 0) {
        const latLng = results[0].geometry.location;

        this.showMap = true;

        setTimeout(() => {
          const mapElement = document.getElementById('map');
          if (mapElement) {
            const map = new google.maps.Map(mapElement, {
              center: latLng,
              zoom: 4,
              mapTypeId: 'roadmap'
            });

            new google.maps.Marker({
              position: latLng,
              map,
              title: location
            });
          }
        }, 100);
      }
    });
  }

  onOutsideClick(event: MouseEvent) {
    this.showMap = false;
    this.isModalOpen = false;
  }


  formatUrl(url: string): string {
    if (!url) return '';
    return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
  }


  hasSocialMediaLinks(): boolean {
    const jd = this.data;
    return !!(jd?.facebook || jd?.facebook_url || jd?.instagram || jd?.instagram_url || jd?.linkedin 
      || jd?.linkedin_url || jd?.website || jd?.website_url);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  //  job description
   toggleDescription() {
    this.showFull = !this.showFull;
  }
  //company - description
   toggleCompanyDescription() {
    this.showFullAboutCom = !this.showFullAboutCom;
  }

}